export const SET_ACTIVE_MODULE_ITEM = 'SET_ACTIVE_MODULE_ITEM';
export const setActiveModuleItem = id => ({ type: SET_ACTIVE_MODULE_ITEM, id });
